import "./SearchResult.css";
import { useData } from "../../consts";
import { useEffect, useState } from "react";
import axios_with_token, {getRcds} from "../../axios_with_token";
import PdtList from "../PdtList/PdtList";

export default function SearchResult(props){
    const {searchFilters} = useData();
    const [pdts, setPdts] = useState();
    const [pdtsCnt, setPdtsCnt] = useState(0);
    useEffect(_=>{
        getRcds('pdts', {filters:searchFilters}).then(r=>{
            console.log('search result r:', r);
            setPdts(r.rcds);
            setPdtsCnt(r.rcdCnt);
        })
    }, [searchFilters]);

    const searchFor = Object.values(searchFilters||{}).join(" , ");
    return <div
        className="container"
    >
        <h1>search result</h1>
        <p>{searchFor?`search for " ${searchFor} "`:''}</p>
        {
            (pdts===undefined)?<strong className="py-3">loading ...</strong>
            :(pdts.length<1)?<strong className="py-3">no product found.</strong>:
            <strong className="my-3">{pdtsCnt} products found.</strong>
        }

        <PdtList
            pdts={pdts}
        />

    </div>
}